import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Helmet } from 'react-helmet';
import queryString from 'query-string';
import {ModalMenu} from 'containers/Modals';
import ModalDisclaimer from './modals/ModalDisclaimer';
import ModalShowPhotoComments from './modals/ModalShowPhotoComments';
import ModalShowPhotoList from './modals/ModalShowPhotoList';
import ModalConfirmDelete from './modals/ModalConfirmDelete';

import GoBackButton from 'components/gobackbutton';
import MenuButton from 'components/menubutton/MenuButton';
import PopupNotifications from 'components/PopupNotifications';

import {getCurrentUser} from 'reducers/currentUser';
import {openMemberPhoto, closeMemberPhoto} from 'reducers/memberPhoto';
import {openPhoto, closePhotoList} from 'reducers/photoList';

import {dt} from 'l10n';

import 'sass/main.scss';
import 'sass/ui-kit/full.scss';

import {getCookie, setCookie} from 'utils/cookie';

class AppContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: '',
            prt: undefined,
            prevLocation: '',
            showModalMenu: false,
            returnPath: undefined,
            showDeleteModal: false,
            showModalDisclaimer: !this.checkDisclaimer(),
        };

        this.savedScrolls = {};
        this.onWindowScroll = this.onWindowScroll.bind(this);

        this.setDisclaimer = this.setDisclaimer.bind(this);
        this.checkDisclaimer = this.checkDisclaimer.bind(this);
    }

    componentDidMount() {
        //this.props.getCurrentUser();
        this.checkModalUrlParams(this.props);

        window.addEventListener('scroll', this.onWindowScroll);
        window.addEventListener('ageverif:success', this.setDisclaimer)
        window.addEventListener('ageverif:error', (event) => { this.setDisclaimer(true); console.log("AgeVerif error:", event.detail.error);   });

        if ('serviceWorker' in navigator) {
            window.addEventListener('load', function() {
                navigator.serviceWorker.getRegistrations().then(function(registrations) {
                    for(let registration of registrations) {
                        if(registration.active.scriptURL.match(new RegExp("service\-worker\.js$"))){
                            console.log("Unregistering SW " + registration.active.scriptURL);
                            registration.unregister();
                        } else {
                            console.log("URL does not match " + registration.active.scriptURL);
                        }

                    }
                }).catch(function(err) {
                    console.log('Service Worker de-registration failed: ', err);
                });
            });
        }

        this.removeDefaultMetaDescription();

        this.checkBobvoyeurReferral();
    }

    componentWillReceiveProps(nextProps) {
        // checkModalUrl closes modal if no modal parameter in location, so
        // we need check modalUrlParams only on location change, not on
        // every change of props 
        if (this.props.location.key == nextProps.location.key) return;
        let modal = this.checkModalUrlParams(nextProps);

        if (this.props.location.pathname !== nextProps.location.pathname && !modal && this.state.showModalMenu) {
            this.setState({showModalMenu: false});
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            if (prevProps.location.search.includes('login')) {
                prevProps.location.search = '';
            }

            const parts = location.pathname.split('/');
            if (parts[parts.length - 4] === 'material') {
                this.setState({ prevLocation: prevProps.location})
            }

            this.onLocationChanged();
        }
    }

    onLocationChanged() {
        this.restoreScroll(this.props.location);
    }

    restoreScroll(location) {
        // window.scrollTo(0, 0)
        let key = location.pathname + location.search;

        this.currentScrollKey = key;
        if (!this.savedScrolls[key]) {
            this.savedScrolls[key] = 0;
        }

        window.scrollTo(0, this.savedScrolls[key]);
    }

    onWindowScroll(event) {
        this.savedScrolls[this.currentScrollKey] = window.scrollY;
    }

    /**
     * Checks props for ModalMenu's `modal` parameter and returns it if it exists
     *
     * @param props
     * @return {string}
     */
    checkModalUrlParams(props) {
        let search = Object.assign({}, queryString.parse(props.location.search));

        let modal = '';

        if (search.hasOwnProperty('login')) {
            modal = 'login';
        } else if (search.hasOwnProperty('register')) {
            modal = 'register';
        } else if (search.hasOwnProperty('confirm_registration')) {
            modal = 'confirmRegistration';
        } else if (search.hasOwnProperty('password_recover')) {
            modal = 'passwordRecover';
        } else if (search.hasOwnProperty('password_change')) {
            modal = 'passwordChange';
        }

        this.setState({modal});

        if (modal) {
            this.setState({showModalMenu: true});
        } else {
            this.setState({showModalMenu: false});
        }

        this.setState({
            returnPath: search.return_path,
            prt: search.prt
        });

        return modal;
    }

    checkDisclaimer() {

        //Do not show disclaimer the the ToS page
        if(/\/cgu\/?$/.test(this.props.location.pathname)) {
            return true;
        }

        let VISITED = getCookie('VISITED') || '';

        let isBot = /bot|crawl|slurp|spider/i.test(navigator.userAgent)

        return VISITED.split(',').filter((entry) => entry == '/disclaimer/').length > 0 || isBot;
    }

    setDisclaimer(forced=false) {
        if ((window.ageverif && window.ageverif.verified) || forced) {
            let VISITED = getCookie('VISITED') || '';
            let entries = VISITED.split(',').filter((entry) => entry != '');
            entries.push('/disclaimer/');

            setCookie('VISITED', entries.join(','), 86400);

            this.setState({showModalDisclaimer: false});

        }

        if (document.referrer) {
            let oRefUrl = new URL(document.referrer);
            if (oRefUrl.hostname && oRefUrl.hostname.indexOf("bobvoyeur") !== -1) {
                setCookie('BOBVOYEUR_REFERRAL', 1, 604800);
            } else if (oRefUrl.hostname && oRefUrl.hostname.indexOf("bob4men")  !== -1) {
                setCookie('BOB4MEN_REFERRAL', 1, 604800);
            }
        }
    }

    removeDefaultMetaDescription() {

        let meta_list = document.getElementsByTagName('meta');
        for(let i in meta_list) {
            let meta = meta_list[i];
            if(meta.getAttribute("name") && meta.getAttribute("name").toLowerCase() === "description") {
                meta.parentNode.removeChild(meta);
                break;
            }
        }
    }

    checkBobvoyeurReferral() {
        if (document.referrer.indexOf('bobvoyeur') !== -1) {
            setCookie('BOBVOYEUR_REFERRAL', 1);
        }
    }

    switchMenu = () => {
        this.setState({showModalMenu: !this.state.showModalMenu});
        if (document && this.state.showModalMenu && location.search.includes('login')) window.history.replaceState({}, '', location.pathname);
    };

    showDeleteConfirmation = () => {
        this.setState({showDeleteModal: true, showModalMenu: false})
    };

    hideDeleteConfirmation = () => {
        this.setState({showDeleteModal: false});
    };

    render() {
        let {
            currentUser,
            pm,
            memberPhoto,
            openMemberPhoto,
            closeMemberPhoto,
            openPhoto,
            closePhotoList,
            location,
            history,
            children
        } = this.props;


        const {showModalMenu, modal, returnPath, prt, showModalDisclaimer, showDeleteModal} = this.state;
        return (
            <div id="app-wrapper">
                <Helmet
                    titleTemplate="%s"
                >
                    <title>{dt('meta', 'BobTV, webcam chat for adults of Bob Voyeur')}</title>
                    <meta name="description" content={dt('meta', 'Videochat rooms to exhibit on webcam for amateur libertines and voyeurs. Nudity and sex webcams are accepted on chat rooms.')}/>
                </Helmet>

                <ModalDisclaimer show={showModalDisclaimer} setDisclaimer={this.setDisclaimer}/>

                <ModalMenu
                    modal={modal}
                    show={showModalMenu}
                    closeFn={() => {
                        this.setState({showModalMenu: false})
                        if (document && location.search.includes('login')) window.history.replaceState({}, '', location.pathname);
                    }}
                    showDelete={this.showDeleteConfirmation}
                    currentUser={currentUser}
                    pm={pm}
                    returnPath={returnPath}
                    prt={prt}
                />

                <MenuButton show={showModalMenu} switchMenu={this.switchMenu} />
                <GoBackButton />
                <ModalConfirmDelete show={showDeleteModal} closeFn={this.hideDeleteConfirmation} />
                <ModalShowPhotoComments
                    show={memberPhoto && !!memberPhoto.memberPhoto}
                    openMemberPhoto={openMemberPhoto}
                    closeFn={closeMemberPhoto}
                    memberPhoto={memberPhoto}
                    location={location}
                    currentUser={currentUser}
                />
                <ModalShowPhotoList
                    photoList={this.props.photoList}
                    closeFn={closePhotoList}
                    openPhoto={openPhoto}
                    currentUser={currentUser}
                />

                {children}

                <PopupNotifications/>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    currentUser: state.currentUser,
    pm: state.pm,
    memberPhoto: state.memberPhoto,
    photoList: state.photoList
});

const mapDispatchToProps = {
    getCurrentUser,
    openMemberPhoto,
    closeMemberPhoto,
    openPhoto,
    closePhotoList
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppContainer))



// WEBPACK FOOTER //
// ./src/components/AppContainer.js